import { useEffect, useState } from "react";

import { axiosInstance } from "@/apis/core";
import Button from "@/components/Button";
import ModalLayout from "@/components/Layout/ModalLayout";
import {
  CAMPUS_CD,
  Community,
  Garret,
  Leaf,
} from "@/pages/Admin/components/OrgManagement/types";

// ---- 이동 모달 ----

interface MoveModalProps {
  communities: Community[];
  selectedUserIds: string[];
  onConfirm: (cmtCd: string, garCd: string, leafCd: string) => void;
  onClose: () => void;
}

const MoveModal = ({
  communities,
  selectedUserIds,
  onConfirm,
  onClose,
}: MoveModalProps) => {
  const [targetCmtCd, setTargetCmtCd] = useState("");
  const [targetGarCd, setTargetGarCd] = useState("");
  const [targetLeafCd, setTargetLeafCd] = useState("");
  const [garrets, setGarrets] = useState<Garret[]>([]);
  const [leafs, setLeafs] = useState<Leaf[]>([]);

  useEffect(() => {
    if (!targetCmtCd) return;
    setTargetGarCd("");
    setTargetLeafCd("");
    setGarrets([]);
    setLeafs([]);
    axiosInstance
      .get("/user-service/api/v1/garret/list", {
        params: { cpsCd: CAMPUS_CD, cmtCd: targetCmtCd },
      })
      .then(res => setGarrets(Array.isArray(res.data) ? res.data : []))
      .catch(console.error);
  }, [targetCmtCd]);

  useEffect(() => {
    if (!targetGarCd) return;
    setTargetLeafCd("");
    setLeafs([]);
    axiosInstance
      .get("/user-service/api/v1/leaf/list", {
        params: { cpsCd: CAMPUS_CD, cmtCd: targetCmtCd, garCd: targetGarCd },
      })
      .then(res => setLeafs(Array.isArray(res.data) ? res.data : []))
      .catch(console.error);
  }, [targetGarCd]);

  return (
    <ModalLayout variant="primary" onClose={onClose}>
      <div className="flex w-80 flex-col gap-4 p-6">
        <p className="text-lg font-medium text-black">
          {selectedUserIds.length}명 이동
        </p>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-1">
            <label className="text-small text-gray-dark">공동체</label>
            <select
              className="rounded-sm border border-gray-dull px-2 py-1.5 text-small outline-none focus:border-primary"
              value={targetCmtCd}
              onChange={e => setTargetCmtCd(e.target.value)}
            >
              <option value="">공동체 선택</option>
              {communities.map(c => (
                <option key={c.cmtCd} value={c.cmtCd}>
                  {c.cmtNm}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-small text-gray-dark">다락방</label>
            <select
              className="rounded-sm border border-gray-dull px-2 py-1.5 text-small outline-none focus:border-primary disabled:bg-gray-50 disabled:text-gray-dull"
              value={targetGarCd}
              onChange={e => setTargetGarCd(e.target.value)}
              disabled={!targetCmtCd}
            >
              <option value="">다락방 선택</option>
              {garrets.map(g => (
                <option key={g.garCd} value={g.garCd}>
                  {g.garNm}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-small text-gray-dark">순</label>
            <select
              className="rounded-sm border border-gray-dull px-2 py-1.5 text-small outline-none focus:border-primary disabled:bg-gray-50 disabled:text-gray-dull"
              value={targetLeafCd}
              onChange={e => setTargetLeafCd(e.target.value)}
              disabled={!targetGarCd}
            >
              <option value="">순 선택</option>
              {leafs.map(l => (
                <option key={l.leafCd} value={l.leafCd}>
                  {l.leafNm}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex gap-2">
          <Button variant="outlined" className="flex-1" onClick={onClose}>
            취소
          </Button>
          <Button
            variant="primary"
            className="flex-1"
            disabled={!targetCmtCd || !targetGarCd || !targetLeafCd}
            onClick={() => onConfirm(targetCmtCd, targetGarCd, targetLeafCd)}
          >
            이동 확인
          </Button>
        </div>
      </div>
    </ModalLayout>
  );
};

export default MoveModal;
